import { render } from "./Navbar.vue?vue&type=template&id=32d7241a&scoped=true"
const script = {}

import "./Navbar.vue?vue&type=style&index=0&id=32d7241a&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/Taiwan_Travel/Taiwan_Travel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32d7241a"]])

export default __exports__